﻿import $ from 'jquery'

window.SaveStatistic = function (type, hotelCode, programCode, user) {
    var rootUrl = $('html').data('root');
    // Deny this url for BingPreview
    var url = (navigator.userAgent.indexOf('BingPreview/1.0b') == -1) ? rootUrl + 'ibe/api/statistic/' : undefined;
    if (url && type && (hotelCode || programCode)) {
        $.ajax({
            method: 'POST',
            url: url,
            cache: false,
            data: {
                type: type,
                hotelCode: hotelCode,
                programCode: programCode,
                userCookie: user != undefined ? user : getCookie('user')
            },
            dataType: 'text',
            success: function (data, status, response) {
            },
            error: function (response, status, error) {
                if ((error != undefined) && (error != null)) {
                    throw error;
                }
            }
        });
    }
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
